import { Box, styled } from '@mui/material';

export const InnerView = styled(Box)<{ autoHeight?: boolean }>`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 32px 24px;
  height: ${({ autoHeight }) => (autoHeight ? 'auto' : '')};
`;
